import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PRIVATE_API } from "../../api/apiIndex";

const initialState = {
  data: null,
  examId: null,
  error: "",
  status: "idle",
  submitStatus: "idle",
  submitData: null,
};

export const startExam = createAsyncThunk(
  "exam/startExam",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.post("/exam/start", data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const submitExam = createAsyncThunk(
  "exam/submitExam",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.post("/submit/create", data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

const examSlice = createSlice({
  name: "exam",
  initialState,
  reducers: {
    resetExam: (state) => {
      state.data = null;
      state.error = "";
      state.examId = null;
    },
    resetSubmit: (state) => {
      state.submitData = null;
      state.error = "";
      state.submitStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      // Create exam
      .addCase(startExam.pending, (state, action) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(startExam.fulfilled, (state, action) => {
        state.status = "success";
        state.error = "";
        state.data = action.payload.data;
        state.examId = action.payload.examId;
      })
      .addCase(startExam.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
      })
      // Submit exam
      .addCase(submitExam.pending, (state, action) => {
        state.submitStatus = "loading";
        state.error = "";
      })
      .addCase(submitExam.fulfilled, (state, action) => {
        state.error = "";
        state.submitData = action.payload.data;
        state.submitStatus = "success";
      })
      .addCase(submitExam.rejected, (state, action) => {
        state.submitStatus = "failed";
        state.error = action.payload.message;
      });
  },
});

export const { resetExam, resetSubmit } = examSlice.actions;

export const getExam = (state) => state.exam.data;
export const getExamID = (state) => state.exam.examId;
export const getExamStatus = (state) => state.exam.status;
export const getExamError = (state) => state.exam.error;

export const getSubmitExam = (state) => state.exam.submitData;
export const getSubmitExamStatus = (state) => state.exam.submitStatus;

export default examSlice.reducer;
